<template>
  <a v-if="types === 'cardone'" class="button check-button" :class="[{'is-primary': isChecked,}]" @click.prevent="toggle">
    <input type="checkbox"
           :name="name"
           :checked="isChecked"
           :value="realVal"
           ref="checkbox"
           :disabled="disabled"
           @change="$emit('change', $event)"
           v-model="realVal">

    <span><slot></slot></span>
  </a>

  <a v-else class="carbutton check-button" :class="[{'is-primary': isChecked,}]" @click.prevent="toggle">
    <input type="checkbox"
           :name="name"
           :checked="isChecked"
           :value="realVal"
           ref="checkbox"
           :disabled="disabled"
           @change="$emit('change', $event)"
           v-model="realVal">
    <span class="icon is-small" v-if="icon"><i class="fa" :class="[iconClass]"></i></span>
    <span><slot></slot></span>
  </a>
</template>
<script>
export default {
  name: "checkButton",
  props: {
    icon: String,
    disabled: Boolean,
    checked: Boolean,
    value: {},
    val: [String, Number, Boolean],
    types:{
      type:String,
      default: 'cardone',
    },
    change: {
      type: Function,
      default() {},
    },
    name: String,
  },
  watch: {
    realVal(val) {
      this.change(val);
    },
    checked(val) {
      this.handleChecked(val);
    },
  },
  data() {
    return {
      isChecked: this.checked,
      realVal: null,
    };
  },

  computed: {
    index() {
      return this.$parent.checkItems ? this.$parent.checkItems.indexOf(this) : null;
    },
    iconClass() {
      return this.icon ? `fa-${this.icon}` : null;
    },
  },

  methods: {
    toggle() {
      this.isChecked = !this.isChecked;

      if (this.val && !this.isChecked) {
        this.realVal = '';
        this.$emit('input', this.realVal);
      } else if (this.val && this.isChecked) {
        this.realVal = this.val;
        this.$emit('input', this.realVal);
      } else if (!this.val && this.isChecked) {
        this.realVal = true;
        this.$emit('input', this.realVal);
      } else {
        this.realVal = false;
        this.$emit('input', this.realVal);
      }
      this.$parent.isCheckboxGroup && this.$parent.updateValue();
    },
    handleChecked(isChecked) {
      this.isChecked = isChecked;
    },
  },
  mounted() {
    if (this.isChecked && !this.value) {
      this.$emit('input', this.$refs.checkbox.value);
    }
    if (this.value === this.val) {
      this.isChecked = true;
    }
  },
};
</script>
<style lang="scss">
.check-button{
  input[type="checkbox"]{
    cursor: pointer;
    opacity: 0;
    outline: none!important;
    position: absolute;
  }
}
.carbutton{
  -moz-appearance: none;
  -webkit-appearance: none;
  align-items: center;
  background-color: white;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  color: #363636;
  display: inline-flex;
  font-size: 14px;
  justify-content: flex-start;
  line-height: 24px;
  padding-left: 8px;
  padding-right: 8px;
  position: relative;
  vertical-align: top;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-radius: 2px;
  cursor: pointer;
  justify-content: center;
  padding-left: 12px;
  padding-right: 12px;
  height: 30px;
  min-width: 80px;
  text-align: center;
  white-space: nowrap;
  &:hover{
   /*  border-color: $primary; */
  }

  &.is-primary{
    /*color: #238af7;
    border: 1px solid #238af7;*/
    background: #e73b2d;
    color: #fff;
   /*  background: url($image_dir + 'check.png') no-repeat right bottom; */
  }

  &.is-primary.on:after{
    color: #fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/uCheckbox/checkButton.vue